import React from "react"
import { CloseIcon } from "../../Icons"
import "./SearchableTagsField.css"

class SearchableTagsField extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      items: this.props.items || [],
      focused: false,
      input: ""
    }
  }

  handleInputChange = e => {
    this.setState({ input: e.target.value })
  }

  handleInputKeyDown = e => {
    if (e.keyCode === 13 && e.target.value === "") {
      e.preventDefault()
      return false
    }
    if (
      e.keyCode === 13 &&
      e.target.value !== "" &&
      !e.target.value.includes(",")
    ) {
      const { value } = e.target
      const trimmedValue = value.trim()
      if (trimmedValue !== "") {
        this.handleSelectGroup(trimmedValue)
      }
      e.preventDefault()
      return false
    }
    if (
      e.keyCode === 13 &&
      e.target.value !== "" &&
      e.target.value.includes(",")
    ) {
      const { value } = e.target
      const list = value.split(",")
      const trimmedList = list.map(item => item.trim())
      const filterList = trimmedList.filter(item => item !== "")

      this.handleMultipleItems(filterList)
      e.preventDefault()
      return false
    }

    /*
    if (
      this.state.items.length &&
      e.keyCode === 8 &&
      !this.state.input.length
    ) {
      this.setState(state => ({
        items: state.items.slice(0, state.items.length - 1)
      }))
    }
    */
  }

  handleSelectGroup = groupName => {
    if (this.state.input !== "" && this.state.items.indexOf(groupName) === -1) {
      this.setState(
        state => ({
          items: [...state.items, groupName],
          input: ""
        }),
        () => {
          const { name } = this.props.field
          const { setFieldValue } = this.props.form
          setFieldValue(name, this.state.items)
        }
      )
    } else {
      this.setState({ input: "" })
    }
  }

  handleMultipleItems = list => {
    if (this.state.input !== "" && this.state.items.indexOf(list) === -1) {
      const previousList = [...this.state.items]
      const addList = list.filter(item => !previousList.includes(item))
      const newList = previousList.concat(addList)
      this.setState(
        state => ({
          items: newList,
          input: ""
        }),
        () => {
          const { name } = this.props.field
          const { setFieldValue } = this.props.form
          setFieldValue(name, this.state.items)
        }
      )
    } else {
      this.setState({ input: "" })
    }
  }

  handleRemoveItem = index => {
    this.setState(
      state => ({
        items: state.items.filter((item, i) => i !== index)
      }),
      () => {
        const { name } = this.props.field
        const { setFieldValue } = this.props.form
        setFieldValue(name, this.state.items)
      }
    )
  }

  handleBlur = () => {
    const value = this.state.input
    console.log(value)
    if (!value.includes(",")) {
      const trimmedValue = value.trim()
      if (trimmedValue !== "") {
        this.handleSelectGroup(trimmedValue)
      }
      return null
    } else if (value.includes(",")) {
      const list = value.split(",")
      const trimmedList = list.map(item => item.trim())
      const filterList = trimmedList.filter(item => item !== "")

      this.handleMultipleItems(filterList)
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.items !== prevProps.items) {
      this.setState(state => ({
        ...state,
        items: this.props.items
      }))
    }
  }

  render() {
    return (
      <div className="SearchableTagsField">
        <input
          value={this.state.input}
          onChange={this.handleInputChange}
          onKeyDown={this.handleInputKeyDown}
          onBlur={this.handleBlur}
          type="text"
          placeholder={this.props.placeholder}
        />
        <label>
          <ul>
            {this.state.items.map((item, i) => (
              <li key={i}>
                {item}
                <span onClick={this.handleRemoveItem.bind(this, i)}>
                  <CloseIcon />
                </span>
              </li>
            ))}
          </ul>
        </label>
        {this.state.input.length > 2 && (
          <div className="options">
            {this.props.options &&
              this.props.options.map(option => {
                const groupName = option.toString()
                if (
                  this.state.items.indexOf(groupName) === -1 &&
                  groupName
                    .toLowerCase()
                    .includes(this.state.input.toLowerCase())
                ) {
                  return (
                    <span
                      key={groupName}
                      onClick={() => this.handleSelectGroup(groupName)}
                    >
                      {groupName}
                    </span>
                  )
                } else {
                  return null
                }
              })}
          </div>
        )}
      </div>
    )
  }
}

export default SearchableTagsField
